import type { FiscalEnvironmentValue } from './api';

/**
 * `invoice-issuance/spec.md` → "Banner de comprobante de prueba en Simulado"
 * / "... en Homologación" / "Sin banner en Producción" (`design.md` §8.3).
 * `environment` absent (older `GET /invoices/fiscal-mode` response, before
 * this PR deploys) falls back to the generic text callers already show —
 * backward compatibility, not a fourth environment.
 */
export function getFiscalModeBannerText(environment: FiscalEnvironmentValue | undefined): string {
  if (environment === undefined) {
    return 'Modo de prueba: los comprobantes no tienen validez fiscal';
  }

  if (environment === 'homologacion') {
    return 'COMPROBANTE DE PRUEBA — SIN VALIDEZ FISCAL (HOMOLOGACIÓN)';
  }

  return 'COMPROBANTE DE PRUEBA — SIN VALIDEZ FISCAL (SIMULADO)';
}
